<!-- <form [formGroup]="updateClientForm" (ngSubmit)="updateClient()" #form="ngForm">
  <mat-form-field class="form-field" appearance="outline">
    <mat-label>First Name</mat-label>
    <input matInput formControlName="firstName" />
    <mat-error *ngIf="hasError('firstName', 'required')"
      >Field is required</mat-error
    >
  </mat-form-field>

  <mat-form-field class="form-field" appearance="outline">
    <mat-label>Last Name</mat-label>
    <input matInput formControlName="lastName" />
    <mat-error *ngIf="hasError('lastName', 'required')"
      >Field is required</mat-error
    >
  </mat-form-field>

  <button
    mat-raised-button
    color="primary"
    type="submit"
    [disabled]="updateClientForm.invalid"
  >
    Update Client
  </button>
</form> -->
Update client
